var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashCan = function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash-can_svg__a)",
    fill: "#163144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.052 1.994H9.93v-.788a.83.83 0 0 0-.832-.83H6.823c-.459.021-.83.371-.83.83v.788H3.87a.83.83 0 0 0-.83.831v1.597c0 .219.174.394.393.394h.328v7.416c0 .896.744 1.64 1.64 1.64h5.141c.897 0 1.64-.744 1.64-1.64v-7.46h.329a.392.392 0 0 0 .394-.394V2.781a.858.858 0 0 0-.853-.787Zm-5.294-.788c0-.021.022-.065.065-.065h2.275c.022 0 .066.022.066.065v.788H6.758v-.788ZM3.827 2.803c0-.022.021-.065.065-.065h8.181c.022 0 .066.022.066.065v1.203H3.827V2.803Zm7.568 9.407a.878.878 0 0 1-.875.875H5.402a.878.878 0 0 1-.875-.875V4.772h6.89v7.438h-.022Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.961 10.678a.392.392 0 0 0 .394-.394V7.42a.392.392 0 0 0-.394-.394.392.392 0 0 0-.394.394v2.887c.022.22.175.372.394.372ZM9.798 10.678a.392.392 0 0 0 .394-.394V7.42a.392.392 0 0 0-.394-.394.392.392 0 0 0-.394.394v2.887a.402.402 0 0 0 .394.372ZM6.123 10.678a.392.392 0 0 0 .394-.394V7.42a.392.392 0 0 0-.394-.394.392.392 0 0 0-.394.394v2.887c0 .22.175.372.394.372Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash-can_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.96 .113)",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgTrashCan;